module.exports = __webpack_public_path__ + "static/media/xoleg_mild_right.56f657df.png";